import Cookie from 'js-cookie';

const twelveMonths = 12 * 30 * 24 * 60 * 60; // twelve months in seconds
const GDPR_COOKIE_KEY = 'hasAcknowledgedGdprUsSite';

export default class GDPRBanner {
  constructor() {
    this.gdprAcknowledgementFlash = this.getGdprAcknowledgementFlash();
    this.gdprAcknowledgementBtn = document.getElementById(
      'js-gdpr-site-us-acknowledgement-btn'
    );
  }

  getGdprAcknowledgementFlash() {
    const elements = document.getElementsByClassName('flash gdpr');
    return elements && elements[0];
  }

  showGdprBannerIfNecessary(geo, store_code) {
    // GDPR banner should only be showon on the US store for EU traffic
    if (geo && geo.continent_code === 'EU' && store_code === 'juul-us') {
      // If the cookie is set, then skip it.
      const hasAcknowledgedGdpr = Cookie.get(GDPR_COOKIE_KEY);
      if (hasAcknowledgedGdpr && hasAcknowledgedGdpr === 'true') {
        return;
      }

      this.showGdprAcknowledgementFlash();
    }
  }

  showGdprAcknowledgementFlash() {
    if (this.gdprAcknowledgementFlash) {
      this.gdprAcknowledgementFlash.style.display = 'block';
      if (this.gdprAcknowledgementBtn) {
        this.gdprAcknowledgementBtn.addEventListener('click', e => {
          e && e.preventDefault();
          this.hideGdprAcknowledgementFlash();
        });
      }
    }
  }

  hideGdprAcknowledgementFlash() {
    if (this.gdprAcknowledgementFlash) {
      Cookie.set(GDPR_COOKIE_KEY, true, { expires: twelveMonths });
      this.gdprAcknowledgementFlash.remove();
    }
  }
}
